import firebase from "firebase/compat/app";
import creditCardType from "credit-card-type";
import { CreditCardType } from "../enums/creditCardType.enum";

export class CreditCardUtils {

	private static CC_TYPE_TO_CREDIT_CARD_TYPE: { [key: string]: CreditCardType } = {
		mastercard: CreditCardType.MASTERCARD,
		visa: CreditCardType.VISA,
		'american-express': CreditCardType.AMEX,
		discover: CreditCardType.DISCOVER
	}

	static getLastFourDigits(creditCardNumber: number | string): number {
		if (!creditCardNumber) {
			return null;
		}
		if (typeof creditCardNumber === 'string') {
			creditCardNumber = +creditCardNumber;
		}
		return creditCardNumber % 10000;
	}

	/** for MM / YY format */
	static getTimestampFromExpiration(expiration: string): firebase.firestore.Timestamp {
		if (!expiration) {
			return null;
		}

		const [month, year] = expiration.split(' / ');
		const fullYear = +`20${year}`;
		const date = new Date(fullYear, (+month) - 1, 1)
		const timestamp = firebase.firestore.Timestamp.fromDate(date);

		return timestamp;
	}

	static getCreditCardTypeByNumber(creditCardNumber: string | number): CreditCardType {
		if (!creditCardNumber) {
			return null;
		}

		if (typeof creditCardNumber === 'number') {
			creditCardNumber = creditCardNumber.toString();
		}

		const creditCard = creditCardType(creditCardNumber);
		if (!creditCard) {
			return null;
		}

		return this.CC_TYPE_TO_CREDIT_CARD_TYPE[creditCard[0]?.type];
	}


	static getCreditCardByName(name: string): CreditCardType {
		if (!name) {
			return null;
		}

		return (CreditCardType as any)?.[name];
	}

	static getMonthByExpirationDate(expiration: string): number {
		if (!expiration) {
			return null;
		}

		return parseInt(expiration.split('/')[0].trim(), 10);
	}

	static getYearByExpirationDate(expiration: string): number {
		if (!expiration) {
			return null;
		}

		const yearSuffix = expiration.split('/')[1].trim();
    	return parseInt("20" + yearSuffix, 10);
	}
}
